import { Component, Input, OnInit } from '@angular/core';
import { WidgetComponent } from 'app/widget/widgets/widget-component';
import { GroupDashboardService } from 'app/groups/services/group-dashboard.service';
import { TranslateService } from '@ngx-translate/core';
import { DashboardDataService } from '@widgets/services/dashboard-data.service';
import { Subscription } from 'rxjs';
import { StoreService } from 'core/services';
import { UtilsWidgetService } from '../services/utils-widget.service';
import { DEFAULT_STUDENT_ACTIVITY } from '../../../assets/constants';

@Component({
  selector: 'lms-students-progress-widget',
  templateUrl: './students-progress-widget.component.html',
  styleUrls: ['./students-progress-widget.component.scss']
})
export class StudentsProgressWidgetComponent implements WidgetComponent, OnInit {
  @Input() data: any;

  public activeStudentsActivity: any = {};
  public totalDurationUnits: string;
  public averageDurationUnits: string;
  public ratioFinished: any;
  public progressSections: any;

  public tooltipText: string;
  public secondaryTooltipText: string;
  private tooltipSubscription: Subscription = new Subscription();
  private groupDashboardSubscription: Subscription = new Subscription();

  constructor(
    public groupDashboardService: GroupDashboardService,
    public dashboardService: DashboardDataService,
    public translate: TranslateService
  ) {}

  public ngOnInit(): void {
    this.tooltipSubscription = StoreService.get(this.data.action).subscribe((tooltipObject) => {
      this.tooltipText = UtilsWidgetService.containTooltip(tooltipObject, this.data.action, this.data.key);
      this.secondaryTooltipText = UtilsWidgetService.containTooltip(
        tooltipObject,
        this.data.action,
        this.data.secondaryKey
      );
    });

    this.totalDurationUnits = this.translate.instant('groups.dashboard.units.hours');
    this.averageDurationUnits = this.translate.instant('groups.dashboard.units.hours');

    this.groupDashboardSubscription = this.groupDashboardService
      .getActivity({
        groupId: this.data.group._id
      })
      .subscribe((activity) => {
        this.activeStudentsActivity = activity || DEFAULT_STUDENT_ACTIVITY;
        this.progressSections = this.parseSections(this.activeStudentsActivity.progressSections);
      });

    this.dashboardService.getRatios({ groupId: this.data.group._id }).subscribe((ratios) => {
      this.ratioFinished = Math.ceil(ratios.ratioFinished);
    });
  }

  private parseSections(progressSections: any[]): any[] {
    return [
      progressSections['0to19'],
      progressSections['20to39'],
      progressSections['40to59'],
      progressSections['60to79'],
      progressSections['80to99'],
      progressSections['100']
    ];
  }

  public ngOnDestroy(): void {
    this.tooltipSubscription.unsubscribe();
    this.groupDashboardSubscription.unsubscribe();
  }
}
